export default {
    BIKES: 'bikes',
    RESERVATIONS: 'reservations',
    USER: 'user',
    LOGIN: 'login',
    SIGNUP: 'signup',
    BIKES_BY_DATES: 'bikesByDates',
    RATING: 'rating'
}